import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Mail, Phone, MapPin, Send, Calendar } from 'lucide-react';
import './ContactPage.css';

const ContactPage = ({ onOpenForm }) => {
  const [step, setStep] = useState(1);
  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    projectType: '',
    message: ''
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setStep(2); // Success state
  };

  return (
    <motion.div 
      className="contact-page"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      <div className="contact-bg-glow"></div>
      <section className="contact-hero">
        <div className="container">
          <motion.h1
            initial={{ y: 20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
          >
            Engineering Your <span>Vision</span>
          </motion.h1>
          <motion.p
            initial={{ y: 20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ delay: 0.1 }}
          >
            Ready to scale? Let's discuss your technical requirements and build a product that defines your category.
          </motion.p>
        </div>
      </section>

      <section className="contact-main">
        <div className="container">
          <div className="contact-grid">
            <div className="contact-info">
              <div className="info-item">
                <div className="info-icon"><Mail /></div>
                <div>
                  <h4>Email Us</h4>
                  <p>hello@amavix.tech</p>
                </div>
              </div>
              <div className="info-item">
                <div className="info-icon"><Phone /></div>
                <div>
                  <h4>Call / WhatsApp</h4>
                  <p>+1 (555) 000-0000</p>
                </div>
              </div>
              <div className="info-item">
                <div className="info-icon"><MapPin /></div>
                <div>
                  <h4>Office</h4>
                  <p>San Francisco, CA</p>
                </div>
              </div>
              
              <div className="booking-card">
                <div className="bc-glow"></div>
                <Calendar className="booking-icon" />
                <h4>Prefer a Direct Meeting?</h4>
                <p>Skip the form and schedule a 15-minute discovery call with our Lead Engineer.</p>
                <button className="btn-book" onClick={onOpenForm}>Book a Strategy Call <Calendar size={16} /></button>
              </div>
            </div>

            <div className="contact-form-container shadow-premium">
              {step === 1 ? (
                <form className="contact-form" onSubmit={handleSubmit}>
                  <div className="form-row">
                    <div className="form-group">
                      <label>Full Name</label>
                      <input 
                        type="text" 
                        name="fullName" 
                        placeholder="John Doe" 
                        value={formData.fullName}
                        onChange={handleInputChange}
                        required 
                      />
                    </div>
                    <div className="form-group">
                      <label>Email Address</label>
                      <input 
                        type="email" 
                        name="email" 
                        placeholder="john@company.com" 
                        value={formData.email}
                        onChange={handleInputChange}
                        required 
                      />
                    </div>
                  </div>
                  <div className="form-group">
                    <label>Inquiry Type</label>
                    <select 
                      name="projectType" 
                      value={formData.projectType}
                      onChange={handleInputChange}
                      required
                    >
                      <option value="">What are you looking for?</option>
                      <option value="web">Full-Stack Development</option>
                      <option value="ai">AI & Machine Learning</option>
                      <option value="design">Product UI/UX Design</option>
                      <option value="audit">Technical Audit</option>
                      <option value="other">General Inquiry</option>
                    </select>
                  </div>
                  <div className="form-group">
                    <label>Brief Project Description</label>
                    <textarea 
                      name="message" 
                      placeholder="Tell us about your goals and technical challenges..." 
                      rows="4"
                      value={formData.message}
                      onChange={handleInputChange}
                      required
                    ></textarea>
                  </div>
                  <button type="submit" className="submit-btn">
                    Send Inquiry <Send size={18} />
                  </button>
                </form>
              ) : (
                <div className="contact-success">
                  <div className="success-icon-wrapper">
                    <Send size={40} />
                  </div>
                  <h3>Launch Sequence Initiated</h3>
                  <p>We've received your inquiry. One of our engineers will review your requirements and reach out within 24 hours.</p>
                  <button className="secondary-btn" onClick={() => setStep(1)}>Send Another Message</button>
                </div>
              )}
            </div>
          </div>
        </div>
      </section>
    </motion.div>
  );
};

export default ContactPage;
